import { useRef, useEffect } from 'react';

import Header from './Header/Header.js';
import Video from './Video/Video.js';
import MainVideo from './MainVideo/MainVideo.js';

import Music from './Music/Music.js';
import Events from './Events/Events.js';
import About from './About/About.js';
import Follow from './Follow/Follow.js';

import './App.css';

function App() {
  const soundWaveVid = useRef();

  useEffect(() => {
    const root = document.querySelector(':root');
    const header = document.querySelector('header');

    function collapseHeader() {
      header.classList.add('collapsed');
    }
    
    function expandHeader() {
      header.classList.remove('collapsed');
    }

    const scrollPadding = 16 // px

    window.addEventListener('scroll', () => {
      // Collapse/expand header
      let scrollAmount = document.documentElement.scrollTop;
      if (scrollAmount > 30) {
        collapseHeader();
      } else if (scrollAmount === 0) {
        expandHeader();
      }
    });

    document.querySelectorAll('a[href^="#"]').forEach((link) => {
      link.addEventListener('click', (e) => {
        e.preventDefault();
        window.location.hash = '#null';
        window.location.hash = new URL(link.href).hash;
      });
    });

    // Scroll to correct elements when hash changes
    function scrollBasedOnHash() {
      let hash = window.location.hash;
      let targetElt = document.getElementById(hash.slice(1));

      if (!targetElt) return; // For example, if empty hash
      
      let scrollHeight = targetElt.offsetTop;
      let headerOffset = header.offsetHeight;
      window.scrollTo({
        top: scrollHeight - headerOffset - scrollPadding
      });
    }

    window.addEventListener('hashchange', () => {
      scrollBasedOnHash();
    });
  
    scrollBasedOnHash(); // Remove to remove hash section sharing
  }, []);

  return (
    <div className="App">
      <Header soundWaveVid={soundWaveVid}></Header>

      <div className="content">
        <MainVideo videoRef={soundWaveVid}></MainVideo>

        <main>
          <div className="info">
            <Music></Music>
            <Events></Events>
            <About></About>
            <Follow></Follow>
          </div>
        </main>
      </div>
    </div>
  );
}

export default App;
